<template>
    <q-table
        :data="score_statement"
        :columns="columns"
        row-key="name"
        :pagination.sync="pagination"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <q-tr slot="body" slot-scope="props" :props="props">
            <q-td key="score_date" :props="props">
                {{ fDate(props.row.score_date) }}
            </q-td>

            <q-td key="title" :props="props">
                {{ props.row.title }}
            </q-td>

            <q-td key="score" :props="props">
                {{ props.row.score ? props.row.score.toFixed(2) : '' }}
            </q-td>
        </q-tr>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['score_statement'],

    data() {
        return {
            columns: [
                {
                    name: 'score_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'score_date',
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: true,
                }
            ],
            page: 1
        }
    },

    computed: {
        ...mapGetters({
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        pagination: {
            get() {
                return  {
                    page: this.page,
                    rowsPerPage: this.num_rows,
                }
            },
            set(val) {
                this.$store.dispatch('datatable/SET_NUM_ROWS', [val.rowsPerPage])
                this.page = val.page
            }
        }
    },

    methods: {
        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        }
    }
}
</script>

<style>

</style>
